import * as React from "react";
const SvgFiRrBowlingPins = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bowling-pins_svg__a)">
      <path
        fill="#062147"
        d="M9 8c.114-.741.3-1.47.554-2.175.228-.586.378-1.2.446-1.825a4 4 0 1 0-8 0c.068.625.218 1.239.446 1.825C2.7 6.53 2.886 7.259 3 8a8.4 8.4 0 0 1-1.264 3.536A11.8 11.8 0 0 0 0 17a11.1 11.1 0 0 0 .986 4.7A4 4 0 0 0 4.61 24h2.78a4 4 0 0 0 3.624-2.3A11.1 11.1 0 0 0 12 17a11.8 11.8 0 0 0-1.736-5.464A8.4 8.4 0 0 1 9 8M6 2a2 2 0 0 1 2 1.973 12 12 0 0 1-.355 1.253A10.7 10.7 0 0 0 7 8H5c-.09-.95-.308-1.882-.646-2.774C4.211 4.772 4.016 4.15 4 4a2 2 0 0 1 2-2m3.2 18.856A2 2 0 0 1 7.39 22H4.61a2 2 0 0 1-1.81-1.143A9.1 9.1 0 0 1 2 17a10.1 10.1 0 0 1 1.512-4.542c.435-.79.81-1.612 1.125-2.458h2.726q.472 1.27 1.125 2.458A10.1 10.1 0 0 1 10 17a9.1 9.1 0 0 1-.8 3.856m13.064-9.32A8.4 8.4 0 0 1 21 8c.114-.741.3-1.47.554-2.175.228-.586.378-1.2.446-1.825a4 4 0 1 0-8 0 7.2 7.2 0 0 0 .446 1.825c.254.705.44 1.434.554 2.175a8.4 8.4 0 0 1-1.264 3.536A11.8 11.8 0 0 0 12 17a11.1 11.1 0 0 0 .986 4.7A4 4 0 0 0 16.61 24h2.78a4 4 0 0 0 3.624-2.3A11.1 11.1 0 0 0 24 17a11.8 11.8 0 0 0-1.736-5.464M18 2a2 2 0 0 1 2 1.973 12 12 0 0 1-.355 1.253A10.7 10.7 0 0 0 19 8h-2c-.09-.95-.308-1.882-.646-2.774C16.211 4.772 16.016 4.15 16 4a2 2 0 0 1 2-2m3.2 18.856A2 2 0 0 1 19.39 22h-2.78a2 2 0 0 1-1.81-1.143A9.1 9.1 0 0 1 14 17a10.1 10.1 0 0 1 1.512-4.542c.435-.79.81-1.612 1.125-2.458h2.726q.472 1.27 1.125 2.458A10.1 10.1 0 0 1 22 17a9.1 9.1 0 0 1-.8 3.856"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bowling-pins_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowlingPins;
